






































import {Component, Prop, Provide, Vue} from 'vue-property-decorator'
import {GithubRepository} from '@/model/resource/GithubRepository'
import {InputGithubRepositorySchema} from '@/schema/resource/GithubRepository/InputGithubRepositorySchema'

@Component
export default class PersistGithubRepositoryView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputGithubRepositorySchema()
  githubRepository = new GithubRepository()

  async created() {
    await this.populate()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.githubRepository.getGithubRepository(id)
    }

    this.$await.done('getGithubRepository')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      this.$toast.abort('system.error.validation')
    }

    await this.githubRepository.persistGithubRepository()
    this.$toast.success('system.success.persist')
    await this.$nav.push('/github-repository/list')
  }
}
